import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QueriesModal from '../QueriesModal/QueriesModal';
import { useAppContext } from '../../context/AppContext';
import { useTranslation } from 'react-i18next';

const HamburgerMenu = ({userId, kTuru}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isQueriesModalOpen, setIsQueriesModalOpen] = useState(false);
    const navigate = useNavigate();
    const [kullaniciTuru, setKullaniciTuru] = useState(localStorage.getItem('kturu'));
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };
        const { t } = useTranslation();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('uni_id');
        localStorage.removeItem('email');
        localStorage.removeItem('kturu')
        navigate('/login');
    };

    function feedbackPage(){
        navigate("/feedback");
        
    }

    function sorgularimPage(){
        navigate("/sorgularim");
    }

    function kurumsalIstatistiklerPage(){
        navigate("/kurumsalIstatistikler")
    }

    useEffect(()=>{
        setKullaniciTuru(localStorage.getItem('kullanici_turu'));
    })
    


    return (
        <div className="relative">
            <button
                onClick={toggleMenu}
                className="hamburger-button p-3 font-bold text-gray-700 hover:text-orange-900"
            >
                <span className="block w-7 h-1 rounded-full bg-orange-700 mb-1"></span>
                <span className="block w-7 h-1 rounded-full bg-orange-700 mb-1"></span>
                <span className="block w-7 h-1 rounded-full bg-orange-700"></span>
            </button>

            {isOpen && (
                <div className="absolute left-0 top-10 w-48 bg-white shadow-md rounded-md z-10">
                    <ul className="p-2 text-left">
                        <li className="p-2 hover:bg-gray-100">
                            <a href="/">  {t('Anasayfa')}</a>
                        </li>
                        <li className="p-2 hover:bg-gray-100">
                            <a href="/profile">  {t('Hesabım')}</a>
                        </li>
                        <li className="p-2 hover:bg-gray-100">
                            <button
                                onClick={sorgularimPage}
                                className=" hover:bg-gray-100"
                            >
                                  {t('Sorgularım')}
                            </button>
                        </li>
                        {kullaniciTuru === "admin" ? (
                            <li className="p-2 hover:bg-gray-100">
                            <button onClick={kurumsalIstatistiklerPage}>
                            {t('Kurumsal İstatistikler')}
                            </button>
                            </li>
                            )  : null     
                        }
                        <li className="p-2 hover:bg-gray-100">
                            <button
                             className=" hover:bg-gray-100"
                             onClick={feedbackPage}
                            >
                                  {t('Geri Bildirim')}
                                </button>
                        </li>
                        {/*
                        <li className="p-2 hover:bg-gray-100">
                            <a href="#">Ayarlar</a>
                        </li>
                        */}
                        <li className="p-2 hover:bg-gray-100">
                            <button onClick={handleLogout}>
                            {t('Çıkış Yap')}
                            </button>
                        </li>
                    </ul>
                </div>
            )}

        </div>
    );
};

export default HamburgerMenu;